"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.Shop = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var Shop = /*#__PURE__*/function () {
  function Shop(json) {
    (0, _classCallCheck2["default"])(this, Shop);
    this.cod = null;
    this.des = null;
    this.lang = null;
    this.country = null;
    this.brand = null;
    this.grpdata = null;
    this.users = null;
    this.admins = null;
    this.pricelist = null;
    this.agency = null;
    this.extra = null;
    this.img = null;
    this.shopemail = null;
    this.cod = json.cod || null;
    this.des = json.des || null;
    this.lang = json.lang || null;
    this.country = json.country || null;
    this.brand = json.brand || null;
    this.grpdata = json.grpdata || null;
    this.users = json.users || null;
    this.admins = json.admins || null;
    this.pricelist = json.pricelist || null;
    this.agency = json.agency || null;
    this.extra = json.extra || null;
    this.img = json.img || null;
    this.shopemail = json.shopemail || null;
  }
  (0, _createClass2["default"])(Shop, [{
    key: "getExtra",
    value: function getExtra() {
      var extra = {};
      if (this.extra) {
        var aExtra = this.extra.split('\t');
        for (var i = 0; i < aExtra.length; i++) {
          var keyVal = aExtra[i].split('=');
          if (keyVal[0] !== '' && keyVal[0] != null && keyVal[0] != undefined) extra[keyVal[0]] = keyVal[1];
        }
      }
      return extra;
    }
  }]);
  return Shop;
}();
exports.Shop = Shop;
//# sourceMappingURL=Shop.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/classes/Shop.js
// module id = 486
// module chunks = 142